import React from "react";

import { Layout } from "antd";

const AdnEmptyLayoutContent = (props) => {
  const { Content } = Layout;

  return (
    //<React.Fragment>
    <Layout className="login-layout">
      <Content style={{ margin: 0, padding: 0 }}>
        <div className="login-layout-background">{props.children}</div>
      </Content>
    </Layout>
    //</React.Fragment>
  );
};

export default AdnEmptyLayoutContent;
